import type { BonusTier } from './APIModels';

export interface UserBonusInfo {
  bonusName?: string;
  promotion_id?: string;
  bonusImageUrl?: string;
  is_selected?: boolean;
  bonusDescription?: string;
  show_info_line?: boolean;
  info_line?: string;
  minDepositAmount?: number;
  maxDepositAmount?: number;
  absoluteBonusValue?: number | null;
  percentBonusValue?: number | null;
  payGroups?: string[];
  maxBonusValue?: number | null;
  productType?: string;
  tiers?: BonusTier[];
  bonusPayGroupsIds?: number[];
  withoutBonus?: boolean;
  overrideBonusDepositAmount?: boolean;
}

/**
 * Returns the minimum deposit amount for a bonus.
 * If tiers are present, uses min_deposit_amount from the first tier (sorted by min_deposit_amount).
 * Otherwise, falls back to the bonus's minDepositAmount.
 */
export const getBonusMinDepositAmount = (bonus: UserBonusInfo | undefined | null): number | undefined => {
  if (!bonus) return undefined;

  if (bonus.tiers?.length) {
    const sortedTiers = [...bonus.tiers].sort((a, b) => (a.min_deposit_amount ?? 0) - (b.min_deposit_amount ?? 0));
    return sortedTiers[0]?.min_deposit_amount ?? bonus.minDepositAmount;
  }

  return bonus.minDepositAmount;
};

export type BonusesDataState = {
  userBonuses: UserBonusInfo[];
  isBonusPresent: boolean;
  isGeneralBonus: boolean;
  infoLine?: string;
  userBonusesByPayGroups: number[] | null;
  selectedBonus?: UserBonusInfo;
  isManuallySelectedBonus: boolean;
  isAllowBonusSelection: boolean;
  isAllBonusesNotSelected: boolean;
};
